import { render, staticRenderFns } from "./LeadsHistory.vue?vue&type=template&id=4ada3e94&"
import script from "./LeadsHistory.vue?vue&type=script&lang=js&"
export * from "./LeadsHistory.vue?vue&type=script&lang=js&"
import style0 from "./LeadsHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports